module.exports = __webpack_public_path__ + "static/img/yyzz.c402549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yyzz.png
// module id = 1454
// module chunks = 3